




















import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
export default defineComponent({
  props: {
    trademarks: {
      type: Array,
      default: () => [],
    },
    legals: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return { isEmpty }
  },
})
